import { States } from '../enums';
import { EmployeeLicenseSummaryLanguage } from './EmployeeLicenseSummaryLanguage';
import { makeArray } from './Model';

export const COMPACT_STATE = 'Compact';

export class EmployeeLicenseSummaryState {
  active = 0;

  applicationInProgress = 0;

  pending = 0;

  expired = 0;

  languages: EmployeeLicenseSummaryLanguage[];

  state: States | 'Compact';

  constructor(obj: any) {
    Object.assign(this, obj);
    this.languages = makeArray(
      obj.languages,
      EmployeeLicenseSummaryLanguage,
    ).toSorted(EmployeeLicenseSummaryLanguage.sort);
    this.state = States.byKey[obj.state] || COMPACT_STATE;
  }

  static sortCompact(
    a: EmployeeLicenseSummaryState,
    b: EmployeeLicenseSummaryState,
  ) {
    if (a.state === COMPACT_STATE) return -1;
    if (b.state === COMPACT_STATE) return 1;
    return a.state?.toString()?.localeCompare(b.state?.toString() || '');
  }
}

export default EmployeeLicenseSummaryState;
